import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private injector: Injector,
                private zone: NgZone) {
    }

    handleError(error: any): void {
        let router = this.injector.get(Router);
        let errorPage = 'error';

        console.error(error);

        if (error instanceof HttpErrorResponse) {
            if (error.status == 401) {
                window.location.reload();
            }
        }
    }
}
